{
	"title": "Crea dichiarazione",
	"backLinkToMaterialDetailsTitle": "Torna ai dettagli del materiale",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Torna a {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Torna a Gestisci dichiarazioni",
	"steps": {
		"firstStep": {
			"title": "Passo 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Passo 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Passo 3",
			"label": "3"
		}
	}
}
